/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Information(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                fill='none'
                height='24'
                viewBox='0 0 32 32'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <circle
                    cx='15.6212'
                    cy='15.5'
                    fill='none'
                    r='14.5'
                    stroke={iconColor || '#9B5A5A'}
                />
                <path
                    d='M15.2272 13.2808H16.3331V20.3926H15.2272V13.2808ZM15.7911 10.2559C15.9913 10.2559 16.1598 10.3169 16.2965 10.439C16.4625 10.5806 16.5455 10.7783 16.5455 11.0322C16.5455 11.2373 16.4821 11.4082 16.3551 11.5449C16.2086 11.7061 16.0182 11.7866 15.7838 11.7866C15.5592 11.7866 15.3761 11.7183 15.2345 11.5815C15.088 11.4399 15.0148 11.2593 15.0148 11.0396C15.0148 10.8003 15.0929 10.6074 15.2491 10.4609C15.3956 10.3242 15.5763 10.2559 15.7911 10.2559Z'
                    fill={iconColor || '#9B5A5A'}
                />
            </svg>
        </SvgIcon>
    );
}